/* ========================================
   Artist Profile — Hero Section
   ======================================== */

function renderHero(artist) {
  const hero = document.getElementById('artist-hero');

  /* Returns a promise that resolves when the cover image is loaded (or immediately for fallback) */
  let coverReady;

  if (artist.coverUrl) {
    const coverImg = document.createElement('img');
    coverImg.className = 'artist-hero__cover';
    coverImg.alt = '';
    hero.insertBefore(coverImg, hero.firstChild);
    coverReady = new Promise(function(resolve) {
      coverImg.onload = resolve;
      coverImg.onerror = resolve;
      coverImg.src = getScaledCloudinaryUrl(artist.coverUrl, 1200, 'f_webp');
    });
  } else {
    const fallback = document.createElement('div');
    fallback.className = 'artist-hero__cover artist-hero__cover--fallback';
    hero.insertBefore(fallback, hero.firstChild);
    if (artist.photoUrl) {
      extractDominantColor(getScaledCloudinaryUrl(artist.photoUrl, 100, 'f_auto')).then(function(color) {
        fallback.style.background = 'linear-gradient(to bottom, ' + color + ' 0%, #0c0c0c 100%)';
      }).catch(function() {
        fallback.style.background = 'linear-gradient(to bottom, #333 0%, #0c0c0c 100%)';
      });
    } else {
      fallback.style.background = 'linear-gradient(to bottom, #333 0%, #0c0c0c 100%)';
    }
    coverReady = Promise.resolve();
  }
  hero.classList.remove('artist-hero--loading');

  const avatar = document.getElementById('artist-avatar');
  avatar.classList.remove('artist-skeleton', 'artist-skeleton--circle');
  if (artist.photoUrl) {
    const avatarImg = document.createElement('img');
    avatarImg.className = 'artist-hero__avatar';
    avatarImg.src = getScaledCloudinaryUrl(artist.photoUrl, 400, 'f_auto');
    avatarImg.alt = artist.name || '';
    avatar.parentNode.replaceChild(avatarImg, avatar);
  }

  const nameEl = document.getElementById('artist-name');
  nameEl.classList.remove('artist-skeleton', 'artist-skeleton--heading');
  nameEl.textContent = artist.name || '';

  const breadcrumbNameElement = document.getElementById('breadcrumb-artist-name');
  if (breadcrumbNameElement) breadcrumbNameElement.textContent = artist.name || '';

  // Add artist badge — per-artist from theme editor blocks
  const nameRow = document.querySelector('.artist-hero__name-row');
  let badgeSetting = null;
  try {
    const badgesEl = document.getElementById('artist-badges-data');
    const badgesMap = badgesEl ? JSON.parse(badgesEl.textContent) : {};
    const artistId = new URLSearchParams(window.location.search).get('id');
    badgeSetting = artistId && badgesMap[artistId] ? badgesMap[artistId] : null;
  } catch (parseError) {
    badgeSetting = null;
  }
  const badgeConfigs = {
    best_seller: { label: 'Best Seller', className: 'artist-hero__badge--best-seller', icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.0498 1C16.0898 1.21 19.3098 4.56016 19.2998 8.66016V9.0498H19.29C19.18 11.1597 18.2104 13.0501 16.7305 14.3701L17.96 20.8301C18.2699 22.45 16.5796 23.7302 15.0996 22.9902L11.6299 21.25L8.26953 22.9404C6.74981 23.6998 5.04018 22.34 5.42969 20.6904L6.87012 14.6299C5.22012 13.3099 4.12 11.3098 4 9.0498V8.66016C4 4.43016 7.43016 1 11.6602 1H12.0498ZM14.9297 15.5801C13.9399 16.0499 12.8201 16.3095 11.6504 16.3096H11.2598C10.3399 16.2595 9.46985 16.0499 8.66992 15.71L7.37988 21.1602L10.75 19.4697C11.31 19.1898 11.9801 19.1898 12.54 19.4697L12.5303 19.4805L16 21.2197L14.9297 15.5801ZM11.6602 2.99023C8.53016 2.99023 6 5.53039 6 8.65039C6.00021 11.7802 8.54029 14.3096 11.6602 14.3096C14.79 14.3095 17.3201 11.7802 17.3203 8.65039C17.3203 5.52044 14.7901 2.99032 11.6602 2.99023ZM11.6504 5.03027C12.1502 5.03044 12.4502 5.35037 12.6201 5.57031C12.7801 5.7903 12.9502 6.1005 13.1201 6.40039L13.21 6.57031C13.22 6.60023 13.24 6.63044 13.25 6.65039L13.3301 6.66992L13.5098 6.70996C13.8297 6.78995 14.1699 6.85998 14.4199 6.95996L14.4404 6.98047C14.7104 7.08054 15.0798 7.29037 15.2197 7.75C15.3597 8.2 15.1803 8.58031 15.0303 8.82031C14.8903 9.06023 14.6604 9.32017 14.4404 9.58008L14.3203 9.71973C14.2904 9.74967 14.27 9.77981 14.25 9.7998C14.2598 9.83895 14.2598 9.91664 14.2598 9.91992L14.2803 10.1104C14.3203 10.4602 14.3498 10.8102 14.3398 11.0801C14.3298 11.3501 14.2599 11.7803 13.8799 12.0703C13.49 12.3601 13.0502 12.2997 12.7803 12.2197C12.5204 12.1498 12.2102 12.0003 11.9004 11.8604L11.7305 11.7803L11.6602 11.75C11.6402 11.76 11.5898 11.7803 11.5898 11.7803L11.4199 11.8604C11.11 12.0003 10.8 12.1397 10.54 12.2197C10.2701 12.2897 9.83042 12.3595 9.44043 12.0596C9.06057 11.7697 8.99051 11.3403 8.98047 11.0703C8.97047 10.8003 9.01004 10.4496 9.04004 10.0996L9.05957 9.90039V9.78027C9.04021 9.76088 8.99349 9.7041 8.99023 9.7002L8.87012 9.5498C8.65014 9.28983 8.43026 9.02978 8.28027 8.7998C8.13033 8.55988 7.95011 8.18025 8.08984 7.73047C8.22984 7.27047 8.60012 7.06996 8.87012 6.95996C9.1201 6.85998 9.45033 6.77995 9.78027 6.70996L9.95996 6.66992C9.98996 6.65992 10.02 6.65039 10.04 6.65039C10.0592 6.6312 10.0876 6.57482 10.0898 6.57031L10.1797 6.40039C10.3496 6.09054 10.5098 5.79028 10.6797 5.57031C10.8497 5.35031 11.1604 5.03027 11.6504 5.03027ZM11.5 7.15039L11.4102 7.32031C11.3302 7.45036 11.1996 7.70971 10.9697 7.88965C10.7297 8.06965 10.4398 8.12039 10.2998 8.15039L10.1201 8.19043C9.97012 8.23043 9.85 8.25027 9.75 8.28027C9.82986 8.37013 9.9098 8.47985 10.0195 8.59961L10.1396 8.75C10.2196 8.84 10.3805 9.02 10.4805 9.25L10.5195 9.34961L10.5498 9.4502C10.5997 9.68988 10.5599 9.92949 10.5498 10.0596L10.5303 10.25C10.5203 10.3899 10.5 10.5199 10.5 10.6299C10.58 10.5899 10.6801 10.55 10.79 10.5L10.96 10.4199C11.08 10.3599 11.3504 10.2197 11.6504 10.2197C11.9501 10.2198 12.2198 10.3599 12.3398 10.4199L12.5098 10.5C12.6197 10.55 12.7099 10.5899 12.7998 10.6299C12.7998 10.5199 12.7795 10.3999 12.7695 10.25L12.75 10.0498C12.74 9.89975 12.7003 9.6197 12.7803 9.33984C12.8603 9.05013 13.0701 8.84049 13.1602 8.73047L13.2803 8.58008L13.29 8.59961C13.3998 8.47987 13.4897 8.37014 13.5596 8.28027C13.4498 8.25034 13.3301 8.22036 13.1904 8.19043L13.0098 8.15039C12.8697 8.12039 12.5895 8.06958 12.3496 7.88965C12.1101 7.70979 11.9802 7.45033 11.9102 7.32031L11.8203 7.15039C11.7603 7.05045 11.7101 6.95009 11.6602 6.87012C11.6102 6.95012 11.56 7.04039 11.5 7.15039Z" fill="white"/></svg>' },
    pro: { label: 'Pro', className: 'artist-hero__badge--pro', icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.5104 19.41C19.0604 19.4101 19.5104 19.8601 19.5104 20.41C19.5104 20.96 19.0604 21.41 18.5104 21.41H5.73015C5.18023 21.4099 4.73015 20.96 4.73015 20.41C4.73015 19.8601 5.18023 19.4101 5.73015 19.41H18.5104ZM11.7106 3.06042C12.0905 2.95049 12.4801 2.99059 12.82 3.18054C13.0599 3.31051 13.2603 3.50995 13.3903 3.74987L16.03 8.77038L19.8405 5.50964C20.4805 4.97993 21.4009 5.08017 21.9108 5.70007L21.9303 5.7196C22.2303 6.0796 22.3306 6.57038 22.2106 7.02038L19.6208 16.37C19.3908 17.1899 18.6405 17.7702 17.7907 17.7704H6.48015C5.62022 17.7703 4.87029 17.1899 4.6403 16.37L2.05046 7.02038C1.95047 6.64041 2.00014 6.25001 2.19011 5.91003C2.38004 5.57014 2.69017 5.3304 3.06999 5.23034C3.51999 5.11034 4.01077 5.20964 4.37077 5.50964L8.19987 8.78991L10.8405 3.78015V3.75964C11.0305 3.41984 11.3408 3.17038 11.7106 3.06042ZM9.90007 9.79968C9.84007 9.91968 9.77011 10.02 9.69011 10.12C9.37011 10.52 8.91004 10.7604 8.40007 10.8104C7.89019 10.8603 7.39058 10.7097 7.00066 10.3798L4.44987 8.1903L6.54069 15.7596H17.6901V15.7499L19.78 8.18054L17.2399 10.3602C17.1301 10.45 17.0304 10.52 16.9206 10.58C15.9906 11.0799 14.82 10.7403 14.32 9.81042L12.11 5.61022L9.90007 9.79968Z" fill="white"/></svg>' },
    new: { label: 'New', className: 'artist-hero__badge--new', icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.1405 1.48976C12.3605 1.10016 12.8199 0.910079 13.2596 1.0298C13.6996 1.1498 13.9999 1.55051 13.9999 2.00051V9.00051H17.9999C18.3599 9.00051 18.69 9.19051 18.87 9.50051C19.0498 9.81044 19.0499 10.1906 18.87 10.5005L11.87 22.5005C11.6899 22.8203 11.3595 23.0005 11.0096 23.0005C10.9198 23.0005 10.8397 22.9902 10.7499 22.9702C10.3101 22.8502 10.0098 22.4503 10.0096 22.0005V15.0005H6.00962C5.64999 15.0004 5.32048 14.8101 5.14048 14.5005C4.96051 14.1906 4.96057 13.8105 5.14048 13.5005L12.1405 1.48976ZM7.74009 13.0005H10.9999C11.5499 13.0005 11.9999 13.4505 11.9999 14.0005V18.3003L16.2596 11.0005H12.9999C12.4501 11.0004 12.0001 10.5502 11.9999 10.0005V5.69973L7.74009 13.0005Z" fill="white"/></svg>' },
    featured: { label: 'Featured', className: 'artist-hero__badge--featured', icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5019 21.2119C16.2619 21.2119 16.0219 21.1519 15.8019 21.0319L11.5119 18.6319L7.22189 21.0319C6.89189 21.2219 6.50189 21.2619 6.13189 21.1619C5.76189 21.0619 5.46189 20.8119 5.27189 20.4819C5.10189 20.1819 5.05189 19.8419 5.11189 19.5019L6.07189 14.6819L2.46189 11.3419C2.18189 11.0819 2.02188 10.7319 2.00188 10.3519C1.98188 9.97186 2.12189 9.60186 2.38189 9.32186C2.61189 9.07186 2.92189 8.91187 3.26189 8.87187L8.14188 8.29186L10.2019 3.83186C10.5319 3.11186 11.3819 2.80186 12.1019 3.13186C12.4119 3.27186 12.6619 3.52186 12.8019 3.83186L14.8619 8.29186L19.7419 8.87187C20.1219 8.92187 20.4619 9.11186 20.7019 9.41186C20.9419 9.71186 21.0419 10.0919 21.0019 10.4719C20.9619 10.8119 20.8019 11.1219 20.5519 11.3519L16.9519 14.6819L17.9119 19.5019C18.0619 20.2719 17.5619 21.0319 16.7919 21.1819C16.7019 21.2019 16.6019 21.2119 16.5119 21.2119H16.5019ZM11.5219 16.5519C11.7619 16.5519 12.0019 16.6119 12.2219 16.7319L15.7119 18.6819L14.9319 14.7619C14.8319 14.2719 14.9919 13.7719 15.3619 13.4319L18.3019 10.7119L14.3319 10.2419C13.8319 10.1819 13.4119 9.87185 13.2019 9.42185L11.5319 5.79187L9.86189 9.42185C9.65189 9.87185 9.22188 10.1819 8.73188 10.2419L4.76189 10.7119L7.70188 13.4319C8.06188 13.7619 8.23189 14.2719 8.13189 14.7619L7.35189 18.6819L10.8419 16.7319C11.0619 16.6119 11.3019 16.5519 11.5419 16.5519H11.5219Z" fill="white"/></svg>' }
  };

  if (badgeSetting && badgeSetting !== 'none' && badgeConfigs[badgeSetting]) {
    const config = badgeConfigs[badgeSetting];
    const badge = document.createElement('span');
    badge.className = 'artist-hero__badge ' + config.className;
    badge.innerHTML = config.icon + ' ' + config.label;
    nameRow.appendChild(badge);
  }

  const profile = artist.artistProfile || artist;
  const artistTitle = artist.title || '';
  document.getElementById('artist-subtitle').textContent = artistTitle;
  initShare(document.getElementById('share-btn'));

  const heroSocial = document.getElementById('artist-hero-social');
  heroSocial.innerHTML = buildSocialHtml(artist, 'artist-hero__social-icon');

  renderArtistDescription(artist.description);

  return coverReady;
}

const ARTIST_DESCRIPTION_EXPANDED_CLASSNAME = 'artist-description--expanded';
const ARTIST_DESCRIPTION_TOGGLE_LABEL_COLLAPSED = 'See More';
const ARTIST_DESCRIPTION_TOGGLE_LABEL_EXPANDED = 'See Less';
const ARTIST_DESCRIPTION_WORD_COUNT_CSS_VARIABLE = '--row-word-count';
/* Fallback word counts for [row 1, middle, row 2]. Middle defaults to 0 so it
   contributes no text on breakpoints where CSS keeps it display:none. */
const ARTIST_DESCRIPTION_ROW_FALLBACK_WORD_COUNTS = [14, 0, 7];

function readRowWordCountFromCss(rowElement, fallbackWordCount) {
  const parsedWordCount = parseInt(
    getComputedStyle(rowElement).getPropertyValue(ARTIST_DESCRIPTION_WORD_COUNT_CSS_VARIABLE),
    10,
  );
  return Number.isFinite(parsedWordCount) && parsedWordCount >= 0
    ? parsedWordCount
    : fallbackWordCount;
}

function isElementDisplayed(element) {
  return getComputedStyle(element).display !== 'none';
}

function splitTextByWordCounts(fullText, wordCountsPerRow) {
  const allWords = fullText.split(/\s+/).filter(Boolean);
  let consumedWordCount = 0;
  const rowTexts = wordCountsPerRow.map((rowWordCount) => {
    const slice = allWords.slice(consumedWordCount, consumedWordCount + rowWordCount).join(' ');
    consumedWordCount += rowWordCount;
    return slice;
  });
  return { rowTexts, hasOverflowingWords: consumedWordCount < allWords.length };
}

/* Binary-search for the largest word-count prefix of `candidateText` that fits
   `rowElement` without horizontal clipping. Sets the row's textContent to the
   fitting prefix and returns the trailing words that didn't fit. */
function fitRowAndReturnOverflow(rowElement, candidateText) {
  rowElement.textContent = candidateText;
  if (rowElement.scrollWidth <= rowElement.clientWidth) {
    return '';
  }
  const allWords = candidateText.split(' ');
  let lowestFittingWordCount = 0;
  let highestUntestedWordCount = allWords.length;
  while (lowestFittingWordCount < highestUntestedWordCount) {
    const midpointWordCount = Math.ceil((lowestFittingWordCount + highestUntestedWordCount) / 2);
    rowElement.textContent = allWords.slice(0, midpointWordCount).join(' ');
    if (rowElement.scrollWidth <= rowElement.clientWidth) {
      lowestFittingWordCount = midpointWordCount;
    } else {
      highestUntestedWordCount = midpointWordCount - 1;
    }
  }
  rowElement.textContent = allWords.slice(0, lowestFittingWordCount).join(' ');
  return allWords.slice(lowestFittingWordCount).join(' ');
}

function joinNonEmpty(...textParts) {
  return textParts.filter(Boolean).join(' ');
}

function attachToggleButtonHandlers(
  wrapperElement,
  toggleButtonElement,
  fullDescriptionElement,
  collapsedToggleParent,
) {
  toggleButtonElement.textContent = ARTIST_DESCRIPTION_TOGGLE_LABEL_COLLAPSED;
  toggleButtonElement.addEventListener('click', () => {
    const isExpanded = wrapperElement.classList.toggle(ARTIST_DESCRIPTION_EXPANDED_CLASSNAME);
    (isExpanded ? fullDescriptionElement : collapsedToggleParent)?.appendChild(toggleButtonElement);
    toggleButtonElement.textContent = isExpanded
      ? ARTIST_DESCRIPTION_TOGGLE_LABEL_EXPANDED
      : ARTIST_DESCRIPTION_TOGGLE_LABEL_COLLAPSED;
  });
}

function paintDescriptionRows(rowElements, collapsedDescription, toggleButtonElement, wrapperElement) {
  const isRowDisplayed = rowElements.map(isElementDisplayed);
  const wordCountsPerRow = rowElements.map((rowElement, rowIndex) =>
    isRowDisplayed[rowIndex]
      ? readRowWordCountFromCss(rowElement, ARTIST_DESCRIPTION_ROW_FALLBACK_WORD_COUNTS[rowIndex])
      : 0,
  );
  const { rowTexts, hasOverflowingWords } = splitTextByWordCounts(
    collapsedDescription,
    wordCountsPerRow,
  );

  /* Visual-overflow cascade: each visible row gets its allocated words plus
     any words that didn't fit in the previous row. Trailing words that don't
     fit the current row are pushed onto the next visible row. */
  let pendingOverflowText = '';
  rowElements.forEach((rowElement, rowIndex) => {
    if (!isRowDisplayed[rowIndex]) {
      rowElement.textContent = '';
      return;
    }
    const combinedText = joinNonEmpty(pendingOverflowText, rowTexts[rowIndex]);
    pendingOverflowText = fitRowAndReturnOverflow(rowElement, combinedText);
  });

  if (toggleButtonElement && !wrapperElement.classList.contains(ARTIST_DESCRIPTION_EXPANDED_CLASSNAME)) {
    toggleButtonElement.hidden = !(hasOverflowingWords || pendingOverflowText.length > 0);
  }
}

function renderArtistDescription(rawDescription) {
  const wrapperElement = document.getElementById('artist-description');
  const fullDescriptionElement = document.getElementById('artist-description-rest');
  const toggleButtonElement = document.getElementById('artist-description-toggle');
  const rowElements = [
    document.getElementById('artist-description-row-1'),
    document.getElementById('artist-description-row-middle'),
    document.getElementById('artist-description-row-2'),
  ];

  if (!wrapperElement || rowElements.some((rowElement) => !rowElement)) return;

  const collapsedDescription = (rawDescription || '').replace(/\s+/g, ' ').trim();
  if (!collapsedDescription) {
    wrapperElement.hidden = true;
    return;
  }

  wrapperElement.hidden = false;
  if (fullDescriptionElement) fullDescriptionElement.textContent = collapsedDescription;

  if (toggleButtonElement) {
    attachToggleButtonHandlers(
      wrapperElement,
      toggleButtonElement,
      fullDescriptionElement,
      toggleButtonElement.parentElement,
    );
  }

  const repaint = () =>
    paintDescriptionRows(rowElements, collapsedDescription, toggleButtonElement, wrapperElement);

  /* Best-effort synchronous paint, then a deferred paint after layout has
     settled — avoids a flash of empty rows while still ensuring measurements
     run against the wrapper's true size on first render. */
  repaint();
  requestAnimationFrame(repaint);

  /* Re-run once webfonts have loaded — initial measurements may have used
     fallback-font metrics, leaving the rows trimmed incorrectly. */
  document.fonts?.ready?.then(repaint);

  /* ResizeObserver covers every subsequent size change (orientation, devtools
     resize, parent reflow). Falls back to window resize on legacy browsers. */
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(repaint).observe(wrapperElement);
  } else {
    window.addEventListener('resize', repaint);
  }
}

function renderStats(klydos, downloadStats) {
  let totalSold = 0;
  let totalFavorites = 0;

  /* "Sold" counts orders placed, matching the backoffice "Total Purchases"
     column. downloadCount only counts codes redeemed on a clock, so it runs
     lower; fall back to it until the API serving purchaseCount is deployed. */
  if (downloadStats && downloadStats.length > 0) {
    downloadStats.forEach(function(collection) {
      const soldForCollection =
        collection.purchaseCount != null
          ? collection.purchaseCount
          : collection.downloadCount;
      totalSold += soldForCollection || 0;
    });
  }

  if (klydos && klydos.length > 0) {
    klydos.forEach(function(klydo) {
      if (klydo.stats) {
        totalFavorites += klydo.stats.favorites || 0;
      }
    });
  }

  document.getElementById('stat-views').textContent = formatNumber(totalSold);
  document.getElementById('stat-klydos').textContent = formatNumber(klydos ? klydos.length : 0);
  document.getElementById('stat-favorites').textContent = formatNumber(totalFavorites);
}

function wireProfileBreadcrumb() {
  wireBreadcrumbReplace('/pages/artists', ['profile-breadcrumb-back', 'profile-breadcrumb-link']);
}
